import { Handle, HandleProps } from "reactflow";

export default function CustomHandler({
    type,
    id,
    position
}: HandleProps) {

    const corAzul = "#007bff"
    const corVerde = "#28a745"

    return (
        <Handle
            {...{ type, position, id }}
            style={{
                backgroundColor: type === "target" ? corAzul : corVerde,
                width: 10,
                height: 10,
                zIndex: 99
            }}
        />)
}